import { useState } from 'react';

interface PaginationProps {
	initialPage?: number;
	initialPerPage?: number;
}

interface UsePaginationReturn {
	currentPage: number;
	perPage: number;
	setCurrentPage: (page: number) => void;
	setPerPage: (perPage: number) => void;
	handlePageChange: (page: number) => void;
}

export const usePagination = ({
	initialPage = 1,
	initialPerPage = 10
}: PaginationProps = {}): UsePaginationReturn => {
	const [currentPage, setCurrentPage] = useState(initialPage);
	const [perPage, setPerPage] = useState(initialPerPage);

	const handlePageChange = (page: number) => {
		setCurrentPage(page);
	};

	return {
		currentPage,
		perPage,
		setCurrentPage,
		setPerPage,
		handlePageChange
	};
};